<template>
    <el-form :ref="formName" class="cus-form2" :model="formdata" :rules="rules" :label-position="labelPosition" :validate-on-rule-change="false" :inline-message="true">
        <el-row>
            <el-col :span="column.colspan || defaultColspan" v-for="(column, index) in formColumns" :key="index">
                <el-form-item :class="[(column.label && column.label.position) || labelPosition, 'item', column.prop]" :prop="column.prop">
                    <span
                        slot="label"
                        :title="column.label"
                        :class="{ 'item-label': true, 'line-height20': labelPosition != 'top' && charLength(column.label) > 8 && !(column.label && column.label.position == 'top') }"
                        v-if="column.label"
                        >{{ (column.label && column.label.content) || column.label }}</span
                    >
                    <ItemInput
                        v-model="formdata[column.prop]"
                        @input="valueChange(column)"
                        @change="blurChange(column)"
                        :readonly="filter_readonly(column)"
                        v-bind="column.config"
                        :type="column.type"
                        :placeholder="column.placeholder"
                        :options="filter_option(column)"
                        @extrabutton-click="ExtraButtonClick($event)"
                        :clearable="true"
                        :showCount="showCount(column)"
                        :collapseTags="column.collapseTags == false ? false : true"
                    ></ItemInput>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import ItemInput from './ItemInput'

export default {
    name: `CusForm2`,
    components: { ItemInput },
    props: {
        uniqueName: String,
        data: Object,
        columns: Array,
        labelWidth: {
            type: String,
            default: `100px`
        },
        labelPosition: {
            type: String,
            validator: function(t) {
                return t === `top` || t === `left` || t === `right`
            },
            default: `left`
        }
    },
    data() {
        return {
            formName: ``,
            formdata: {}
        }
    },
    created() {
        this.formName = this.uniqueName || `fn` + _.now()
        this.lastdata = {}
    },
    computed: {
        formColumns() {
            let that = this
            let newcs = this.columns.map(function(value, index, array) {
                if (that.data[value.prop] == undefined) {
                    that.data[value.prop] = value.default
                }
                if (that.lastdata[value.prop] != that.data[value.prop] || !_.has(that.formdata, value.prop)) {
                    // if(',multiselect,groupmultiselect,remotemultiselect,'.indexOf(`,${value.type},`)>-1){
                    //   that.lastdata[value.prop] =that.data[value.prop]||[]
                    // }else
                    if (`,rbool,bool`.indexOf(`,${value.type},`) > -1) {
                        that.lastdata[value.prop] = !!that.data[value.prop]
                        that.$set(that.formdata, value.prop, that.data[value.prop] == undefined ? value.default : !!that.data[value.prop]) // 解决 bool类型赋值
                    } else {
                        that.lastdata[value.prop] = that.data[value.prop]
                        that.$set(that.formdata, value.prop, that.data[value.prop] == undefined ? value.default : that.data[value.prop]) // 解决 bool类型赋值
                    }
                }
                return _.cloneDeep(value)
            })
            that.formdata.origion = { ...that.data }
            return newcs
        },
        defaultColspan() {
            return this.formColumns.length > 6 ? 12 : 24
        },
        rules() {
            let r = {}
            _.filter(this.columns, function(c) {
                return c.validate && c.validate.length > 0
            }).forEach(function(c) {
                r[c.prop] = c.validate
            })
            return r
        }
    },
    methods: {
        confirm() {
            let that = this
            let fn = that.formName
            this.$refs[fn].validate(valid => {
                if (valid) {
                    let d = Object.assign({}, that.formdata.origion, { ...that.formdata })
                    delete d.origion
                    that.$emit(`confirm`, d)
                } else {
                    return false
                }
            })
        },
        validateField(prop) {
            let that = this
            let fn = that.formName
            this.$refs[fn].validateField(prop)
        },
        clearField() {
            this.formdata = this.lastdata
            this.lastdata = {}
            // this.$refs[this.formName].resetFields()
        },
        valueChange(column) {
            // 触发change事件
            // this.$forceUpdate()
            if (column.change) {
                column.change(this, { row: this.formdata, area: `form` })
            }
        },
        blurChange(column) {
            // 触发change事件
            if (column.blurchange) {
                column.blurchange(this, { row: this.formdata, area: `form` })
            }
        },
        filter_option(column) {
            let that = this
            if (column.options && _.isFunction(column.options)) {
                return column.options(this, { row: that.formdata, column, area: `form` })
            }
            return column.options
        },
        filter_readonly(column) {
            let that = this
            if (column.readonly && _.isFunction(column.readonly)) {
                return column.readonly(this, { row: that.formdata, column, area: `form` })
            }
            return column.readonly
        },
        ExtraButtonClick($event) {
            this.$emit(`extrabutton-click`, { ...$event, formdata: this.formdata })
        },
        charLength(str) {
            // 先把中文替换成两个字节的英文，在计算长度
            return ((str && str.content) || str || ``).replace(/[\u0391-\uFFE5]/g, `aa`).length
        },
        showCount(column) {
            if (!column || !column.showCount) { return 1 }
            return column.showCount
        }
    }
}
</script>

<style scoped  lang="less">
.cus-form2 {
    width: 100%;
    text-align: right;
    .item-label {
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        // white-space: nowrap;
        text-align: right;
        text-align-last: right;
    }
}
</style>
<style lang="less">
.cus-form2 {
    .el-form-item {
        margin-bottom: 10px;
    }
    .el-form-item.left {
        .el-form-item__label {
            width: 110px;
        }
        .el-form-item__content {
            margin-left: 110px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/CusForm2.vue